import { motion, AnimatePresence } from "framer-motion";
import { routesSearch } from "../../routesSearch";

export default function ModalSearch({ setSearchModalOpen, searchModalOpen }) {
  

  return (
    <AnimatePresence>
      {searchModalOpen && (
        <motion.div
          key="modal-background"
          onClick={() => setSearchModalOpen(false)}
          className="fixed inset-0 bg-black/50 bg-opacity-50 flex items-start pt-10 justify-center z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        >
          <motion.div
            key="modal-content"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className="bg-background rounded-full shadow-md px-10 py-2 flex flex-row items-center sm:w-[600px] w-[350px]"
          >
            <select className="border-none text-text bg-background focus:outline-none w-32 font-poppina text-sm focus:ring-0">
              {routesSearch.map((route) => (
                <option value={route.path} key={route.name}>
                  {route.name}
                </option>
              ))}
            </select>
            <input
              className="border-none bg-background text-text focus:outline-none focus:border-none rounded-full focus:ring-0 sm:w-[400px] w-[100px]"
              type="text"
              placeholder="Buscar"
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}